export const HeadingTwo = ({ children }) => {
  return <h2 className="text-2xl leading-relaxed font-bold mb-2 text-gray-800 ">{children}</h2>
}
  
  export default HeadingTwo
  